import axiosAem from '@/services/http/axiosAem'
import { logger } from '@/services/logger'
import { env } from '@accor/customer-core/env'

interface PanelItem {
  id: string
  text: string
  type?: string
  tracking?: string
  url?: string
  highlight?: boolean
  classes?: string
}

interface PushItem {
  id: string
  url: string
  src: string
  alt: string
  title: string
  desc: string
  buttonText: string
  type: string
  tracking?: string
}

export interface HeaderItem {
  id: string
  text: string
  tracking?: string
  target?: string
  url?: string
  panels?: Array<Array<PanelItem>>
  pushs?: Array<PushItem>
}

export type HeaderItemsResponse = HeaderItem[]

export const getHeaderItems = async (locale: string): Promise<HeaderItemsResponse> => {
  try {
    const { data } = await axiosAem.get('/accorApi/header', {
      params: {
        lang: locale,
        brand: 'all'
      }
    })

    data.forEach((item: HeaderItem) => {
      if (item.url) {
        item.url = env.filterAllAccorComByEnv(item.url)
      }

      item.panels?.forEach((panel: Array<PanelItem>) => {
        panel.forEach((panelItem: PanelItem) => {
          if (panelItem.url) {
            panelItem.url = env.filterAllAccorComByEnv(panelItem.url)
          }
        })
      })

      item.pushs?.forEach((push: PushItem) => {
        if (push.url) {
          push.url = env.filterAllAccorComByEnv(push.url)
        }
      })
    })

    return data
  } catch (error) {
    logger.error(error)

    return []
  }
}

export const getFooterHtml = async (locale: string): Promise<string> => {
  try {
    const { data } = await axiosAem.get(
      `/accorApi/shared-aem-components/footer/footer_minimize/${locale}.html`,
      {
        params: {
          brand: 'all'
        },
        responseType: 'text'
      }
    )
    return data
  } catch (error) {
    logger.error(error)
    return ''
  }
}
